<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label v-if="o.action=='add'">Ajouter un règlement</label>
                    <label v-if="o.action=='edit'">Supprimer un règlement</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Règlement</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-select">
                            <label>Méthode</label>
                            <select v-model="o.method" :disabled="is_disabled">
                                <option v-for="p of invoice.lists.paymentstypes" :key="p.id" :value="p.label">{{p.label}}</option>
                            </select>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Date</label>
                            <input type="date" v-model="o.payment_date" :disabled="is_disabled">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Montant</label>
                            <input type="number" v-model="o.amount" :disabled="is_disabled">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line">
                        <div class="mcf-page-editor-column-text">
                            <label>Commentaire</label>
                            <textarea type="text" v-model="o.note" placeholder=""></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        invoice:Object,
        payment:Object,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            o: this.payment
        };
    },
    computed:{
        is_disabled: function(){
            return (this.payment.action=='edit');
        }
    },
    created() {
        
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_save:function(){
            this.save(this.o);
        }
    }
}
</script>